import React, { Component } from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { connect } from "react-redux";
import { ConfirmDelete } from "MODULES/shared/components";
import * as actions from "../../actions/attachments";

export class Delete extends Component {
  static propTypes = {
    attachment: PropTypes.instanceOf(Map).isRequired,
    destroy: PropTypes.func.isRequired,
    resourceType: PropTypes.string.isRequired,
    label: PropTypes.string
  };

  state = {
    open: false
  };

  open = () => this.setState({ open: true });

  close = () => this.setState({ open: false });

  destroy = () => {
    const { attachment, destroy, resourceType } = this.props;
    destroy(attachment.get("id"), resourceType);
  };

  render() {
    return (
      <div>
        <button className="btn-link" onClick={this.open}>
          <span className="text-danger">
            <i className="fa fa-fw fa-close" />
            {this.props.label}
          </span>
        </button>
        <ConfirmDelete
          onConfirm={this.destroy}
          close={this.close}
          open={this.state.open}
        >
          <strong>Heads up!</strong> Are you sure you want to delete this?
        </ConfirmDelete>
      </div>
    );
  }
}

export default connect(undefined, { destroy: actions.destroyAttachment })(
  Delete
);



// WEBPACK FOOTER //
// ./app/modules/shared/components/Attachments/Delete.jsx